import { render, staticRenderFns } from "./PressingIcon.vue?vue&type=template&id=bbd1d17c&"
import script from "./PressingIcon.vue?vue&type=script&lang=js&"
export * from "./PressingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports